import React from "react";
import "./Chatbot.css";

export default function Chatbot() {
  return (
    <>
      {/* Desktop chatbot */}
      <iframe
        src="https://chat.sapiencia.ai/widget"
        className="sapiencia-chatbot-desktop"
        allow="clipboard-write"
        title="Sapiencia AI Chat"
      />

      {/* Mobile chatbot */}
      <button
        className="sapiencia-mobile-chat-button"
        onClick={() => {
          document.body.classList.add("sapiencia-chat-open");
        }}
      >
        💬
      </button>

      <div className="sapiencia-mobile-chat-panel">
        <button
          className="sapiencia-mobile-chat-close"
          onClick={() => {
            document.body.classList.remove("sapiencia-chat-open");
          }}
        >
          ×
        </button>

        <iframe
          src="https://chat.sapiencia.ai/widget?mode=inline"
          className="sapiencia-mobile-chat-frame"
          allow="clipboard-write"
          title="Sapiencia AI Chat Mobile"
        />
      </div>
    </>
  );
}